import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Form } from 'components/layout'
import { FloatingBar, FormButton } from 'components/misc'
import { AJEventAddress, AJEventDates, AJEventOverview, AJGeneralInfo } from 'components/sections/adventurous-journeys'
import { form } from 'helpers/decorators'
import { apiActivities, apiAjTemplates, apiCodeLists, apiCommon, apiLists } from 'helpers/decorators/api'
import { validate } from 'models/aj-templates'
import { mapSchema } from '../../../../models/aj-templates'

@apiCodeLists([
  'ajEventCategories',
  'modeOfTransportTypeList',
  'awardLevelTypes'
])
@apiLists({ transportationMode: true })
@apiCommon({
  countries: true
})
@apiActivities({
  template: 'nested',
  activityCategories: false,
  ajTypes: true
})
@apiAjTemplates({
  detail: true
})
@form({
  form: 'ajTemplateForm',
  initialProps: 'ajTemplates.detail',
  initialPropsMapper: mapSchema,
  validate
})
class AjTemplates extends Component {
  static propTypes = {
    isUpdateForm: PropTypes.bool,
    pristine: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    codeLists: PropTypes.object.isRequired,
    lists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    createAjTemplate: PropTypes.func.isRequired,
    updateAjTemplate: PropTypes.func.isRequired,
    onActivityParentChange: PropTypes.func.isRequired,
    onAjTypeChange: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    deleteAjEventTemplate: PropTypes.func.isRequired,
    values: PropTypes.object,
    ajTemplates: PropTypes.object
  }

  render() {
    const {
      codeLists,
      values,
      common,
      activities,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      handleSubmit,
      createAjTemplate,
      updateAjTemplate,
      isUpdateForm,
      change,
      onActivityParentChange,
      onAjTypeChange,
      ajTemplates,
      lists
    } = this.props

    return (
      <Form className="form" loading={ajTemplates.loading} isTemplate>
        <div className="row">
          <div className="col-xs-6">
            <div className="base-margin--top">
              <AJGeneralInfo
                data={values}
                change={change}
                eventTypes={codeLists.ajEventCategories.list}
                activities={activities}
                transportationModeList={lists.transportationMode.list}
                awardLevels={codeLists.awardLevelTypes.list}
                onActivityParentChange={onActivityParentChange}
                onAjTypeChange={onAjTypeChange}
                isTemplate
              />
            </div>
          </div>
          <div className="col-xs-6">
            <AJEventOverview
              data={ajTemplates}
              modal={this.props.modal}
              onDelete={this.props.deleteAjEventTemplate}
              isTemplate
            />
          </div>
        </div>

        <AJEventAddress change={change} countries={common.countries.list} />
        <FloatingBar>
          <FormButton
            pristine={pristine}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
            invalid={invalid}
            type="submit"
            onClick={
              (isUpdateForm && handleSubmit(data => updateAjTemplate(data))) ||
              handleSubmit(data => createAjTemplate(data))
            }
          >
            <FormattedMessage id="button.save" defaultMessage="Save" />
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default AjTemplates
